export const SET_CURRENT_GROUP = 'main/SET_CURRENT_GROUP';
export const SET_PUBLIC_GROUP = 'main/SET_PUBLIC_GROUP';

export const setCurrentGroup = group => ({
  type: SET_CURRENT_GROUP,
  group,
});

export const setPublicGroup = group => ({
  type: SET_PUBLIC_GROUP,
  group,
});



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./main/actions/group-actions.ts